export default __webpack_public_path__ + "static/media/Ambient, Yellow.a4f2b839.png";